"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import classNames from "classnames";
import React, { forwardRef } from "react";
import { darkTheme, lightTheme } from "../../../tokens/tokens-css";
import * as styles from "./Label-css";
export const Label = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      size = "m",
      element = "span",
      secondary,
      align,
      long,
      hidden,
      theme,
      className,
      id,
      children,
      htmlFor,
      disabled,
      truncate
    } = _b, rest = __objRest(_b, [
      "size",
      "element",
      "secondary",
      "align",
      "long",
      "hidden",
      "theme",
      "className",
      "id",
      "children",
      "htmlFor",
      "disabled",
      "truncate"
    ]);
    const LabelElement = htmlFor ? "label" : element;
    return /* @__PURE__ */ React.createElement(
      LabelElement,
      __spreadValues({
        id,
        htmlFor,
        className: classNames(
          "kl-label",
          className,
          `kl-label--size-${size}`,
          {
            [darkTheme]: theme === "dark",
            [lightTheme]: theme === "light",
            "kl-label--secondary": secondary,
            "kl-label--hidden": hidden,
            "kl-label--long": long,
            "kl-label--disabled": disabled,
            [`kl-label--align-${align}`]: align
          },
          styles.label({ size, secondary, align, long, hidden, disabled, truncate })
        ),
        ref
      }, rest),
      children
    );
  }
);
